import {PROFILE_ACTION} from "../helper/constant";

const initState = {
    bottomHolder: false
}


const profileReducer = (state = initState, action) => {
    const {type, payload} = action

    switch (type) {
        case PROFILE_ACTION.BOTTOM_CONTROL:
            return {...state, bottomHolder: payload}
        case PROFILE_ACTION.SEC_BOTTOM_CONTROL:
            return {...state, bottomHolder: payload}
     default:
      return state
    }

}


export default profileReducer
